import { Flex, Input, InputNumber, Switch, Tooltip, Typography } from "antd";
import { useSelector } from "react-redux";
const { Text } = Typography;

const DispatchText = ({
  id,
  dispatch_fee,
  member_dispatch_fee,
  isDefault,
  header,
  body,
  checkboxText,
  onChange,
  dispatchVisibility = true,
  unit_price,
}) => {
  const { organizationData } = useSelector((state) => state?.organization);

  const handleDispatchToggle = (e, id) => {
    if (!e) {
      const dispatchObj = {
        dispatch_header:
          header?.trim() === ""
            ? organizationData?.default_dispatch_header
            : header,
        dispatch_body:
          body?.trim() === "" ? organizationData?.default_dispatch_body : body,
        dispatch_text:
          checkboxText?.trim() === ""
            ? organizationData?.default_dispatch_text
            : checkboxText,
      };
      onChange(
        {
          use_default_dispatch: e,
          dispatch_header: dispatchObj?.dispatch_header,
          dispatch_body: dispatchObj?.dispatch_body,
          dispatch_text: dispatchObj?.dispatch_text,
        },
        id
      );
    } else {
      onChange({ use_default_dispatch: e }, id);
    }
  };

  const isHCP = organizationData?.organization_provider === 'HCP';

  return (
    <Flex vertical gap={20} style={{ width: "100%" }}>
      <Flex style={{ width: "100%" }} align="flex-start" gap={20} wrap>
        <Flex vertical gap={10} style={{ minWidth: "140px" }}>
          <Text type="secondary" strong underline>
            {isHCP?"Service Fee":"Dispatch Fee"}
          </Text>
          <InputNumber
            size="middle"
            addonBefore="$"
            min={0}
            value={dispatch_fee}
            onChange={(e) => onChange({ dispatch_fee: e }, id)}
            placeholder="Dispatch Fee"
            style={{ width: "120px" }}
          />
        </Flex>

        {!isHCP && (
          <Flex vertical gap={10} style={{ minWidth: "160px" }}>
            <Text type="secondary" strong underline>
              Member Dispatch Fee
            </Text>
            <InputNumber
              size="middle"
              addonBefore="$"
              min={0}
              value={member_dispatch_fee}
              onChange={(e) => onChange({ member_dispatch_fee: e }, id)}
              placeholder="Member Dispatch Fee"
              style={{ width: "120px" }}
            />
          </Flex>
        )}

        {/* Unit Price */}
        {isHCP && (
          <Flex vertical gap={10} style={{ minWidth: "140px" }}>
            <Text type="secondary" strong underline>
              Unit Price
            </Text>
            <InputNumber
              size="middle"
              addonBefore="$"
              min={0}
              value={unit_price}
              onChange={(e) => onChange({ unit_price: e }, id)}
              placeholder="Unit Price"
              style={{ width: "120px" }}
            />
          </Flex>
        )}

        {dispatchVisibility && (dispatch_fee > 0 || member_dispatch_fee > 0) && (
          <Flex vertical gap={10} style={{ minWidth: "200px" }}>
            <Text type="secondary" strong underline>
              {isHCP ? "Use Default Service Text" : "Use Default Dispatch Text"}
            </Text>
            <Switch
              checked={isDefault}
              size="middle"
              onChange={(e) => handleDispatchToggle(e, id)}
              style={{ width:30 }}
            />
          </Flex>
        )}
      </Flex>

      {(dispatch_fee > 0 || member_dispatch_fee > 0) && (
        <Tooltip
          title="Use {{dispatch_fee}} to dynamically include the dispatch fee"
          placement="bottomLeft"
        >
          <Flex vertical gap={10} style={{ width: "100%" }}>
            <Text type="secondary" strong underline>
              {isHCP ? "Service Header" : "Dispatch Header"}
            </Text>
            <Input.TextArea
              autoSize={{ minRows: 1, maxRows: 3 }}
              placeholder="Custom Dispatch Heading"
              maxLength={250}
              showCount
              allowClear
              disabled={isDefault}
              value={
                !isDefault
                  ? header
                  : organizationData?.default_dispatch_header
              }
              onChange={(e) =>
                onChange({ dispatch_header: e.target.value }, id)
              }
              style={{ width: "100%" }}
            />
          </Flex>
        </Tooltip>
      )}

      {/* Dispatch Body */}
      {(dispatch_fee > 0 || member_dispatch_fee > 0) && (
        <Tooltip
          title="Use {{dispatch_fee}} to dynamically include the dispatch fee"
          placement="bottomLeft"
        >
          <Flex vertical gap={10} style={{ width: "100%" }}>
            <Text type="secondary" strong underline>
              {isHCP ? "Service Body" : "Dispatch Body"}
            </Text>
            <Input.TextArea
              autoSize={{ minRows: 2, maxRows: 5 }}
              placeholder="Custom Dispatch Text"
              maxLength={250}
              showCount
              allowClear
              disabled={isDefault}
              value={
                !isDefault
                  ? body
                  : organizationData?.default_dispatch_body
              }
              onChange={(e) => onChange({ dispatch_body: e.target.value }, id)}
              style={{ width: "100%" }}
            />
          </Flex>
        </Tooltip>
      )}
      {(dispatch_fee > 0 || member_dispatch_fee > 0) && (
        <Tooltip
          title="Customize the text for the dispatch checkbox"
          placement="bottomLeft"
        >
          <Flex vertical gap={10} style={{ width: "100%" }}>
            <Text type="secondary" strong underline>
              {isHCP ? "Service Checkbox Text" : "Dispatch Checkbox Text"}
            </Text>
            <Input.TextArea
              autoSize={{ minRows: 1, maxRows: 3 }}
              placeholder="Custom Checkbox Text"
              maxLength={25}
              showCount
              allowClear
              disabled={isDefault}
              value={
                !isDefault
                  ? checkboxText
                  : organizationData?.default_dispatch_text
              }
              onChange={(e) =>
                onChange({ dispatch_text: e.target.value }, id)
              }
              style={{ width: "100%" }}
            />
          </Flex>
        </Tooltip>
      )}
    </Flex>
  );
};

export default DispatchText;
